var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 2H5V30H27V2ZM5 1C4.44772 1 4 1.44772 4 2V30C4 30.5523 4.44772 31 5 31H27C27.5523 31 28 30.5523 28 30V2C28 1.44772 27.5523 1 27 1H5Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2915 21.7192C7.39434 22.9673 4.55703 25.7177 4.07324 29H5.08634C5.38539 27.278 6.45067 25.6841 8.11472 24.436C9.21245 23.6127 10.5561 22.9543 12.0662 22.5306C11.7835 22.2849 11.524 22.0132 11.2915 21.7192Z",
    fill: "#9B9B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9338 22.5306C21.4439 22.9543 22.7876 23.6127 23.8853 24.436C25.5493 25.6841 26.6146 27.278 26.9137 29H27.9268C27.443 25.7177 24.6057 22.9673 20.7085 21.7192C20.476 22.0132 20.2165 22.2849 19.9338 22.5306Z",
    fill: "#9B9B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 23C18.7614 23 21 20.7614 21 18C21 15.2386 18.7614 13 16 13C13.2386 13 11 15.2386 11 18C11 20.7614 13.2386 23 16 23ZM16 24C19.3137 24 22 21.3137 22 18C22 14.6863 19.3137 12 16 12C12.6863 12 10 14.6863 10 18C10 21.3137 12.6863 24 16 24Z",
    fill: "#9B9B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8.5C7 8.22386 7.22386 8 7.5 8H24.5C24.7761 8 25 8.22386 25 8.5C25 8.77614 24.7761 9 24.5 9H7.5C7.22386 9 7 8.77614 7 8.5Z",
    fill: "#9B9B9B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.5C7 5.22386 7.22386 5 7.5 5H12.5C12.7761 5 13 5.22386 13 5.5C13 5.77614 12.7761 6 12.5 6H7.5C7.22386 6 7 5.77614 7 5.5Z",
    fill: "#9B9B9B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 5.5C21 5.22386 21.2239 5 21.5 5L24.5 5C24.7761 5 25 5.22386 25 5.5C25 5.77614 24.7761 6 24.5 6L21.5 6C21.2239 6 21 5.77614 21 5.5Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCover);
export default __webpack_public_path__ + "static/media/ico_cover.1d551321d23edc0b897bd8cbcac7a1de.svg";
export { ForwardRef as ReactComponent };